import { cva, type VariantProps } from 'class-variance-authority'
import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

// Each key maps to a literal class so Tailwind can see it: size to the
// text-lp-eyebrow-* tokens (9 / 10 / 11px), tracking to the tracking-lp-*
// ladder (0.28 / 0.32 / 0.40em).
const eyebrow = cva('font-serif uppercase', {
    variants: {
        size: {
            sm: 'text-lp-eyebrow-sm',
            md: 'text-lp-eyebrow-md',
            lg: 'text-lp-eyebrow-lg',
        },
        tracking: {
            '28': 'tracking-lp-28',
            '32': 'tracking-lp-32',
            '40': 'tracking-lp-40',
        },
        tone: {
            muted: 'text-muted-fg',
            ink: 'text-ink',
        },
    },
    defaultVariants: { size: 'md', tracking: '28', tone: 'muted' },
})

/**
 * Renders the landing's micro-label: serif, uppercase, widely tracked.
 * Layout (margins, borders, flex) comes in through `className`.
 */
export function Eyebrow({
    as: Tag = 'div',
    size,
    tracking,
    tone,
    className,
    children,
}: VariantProps<typeof eyebrow> & {
    as?: 'div' | 'span' | 'header' | 'figcaption'
    className?: string
    children: ReactNode
}) {
    return (
        <Tag className={cn(eyebrow({ size, tracking, tone }), className)}>
            {children}
        </Tag>
    )
}
